<template>
  <v-menu
    ref="menu"
    v-model="menu2"
    :close-on-content-click="false"
    :nudge-right="40"
    :return-value.sync="time"
    lazy
    transition="scale-transition"
    offset-y
    full-width
    max-width="290px"
    min-width="290px"
  >
  <v-text-field
    slot="activator"
    :class="errorClass"
    :counter="counter"
    :error-messages="errorMessages"
    :hint="hint"
    :label="label"
    :name="name"
    :prepend-icon="prepend"
    :prepend-icon-cb="prependCb"
    v-model="_value"
    readonly
  ></v-text-field>
  <has-error :form="form" :field="name"></has-error>
  <v-time-picker
    v-if="menu2"
    v-model="_value"
    full-width
    :min="min"
    :format="format"
    @click:minute="$refs.menu.save(_value)"
  ></v-time-picker>
  format: {{ format }}
  </v-menu>
</template>

<script>
export default {
  name: 'time-picker',

  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    hint: {
      type: String
    },
    vErrors: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      required: true
    },
    prepend: {
      type: String,
      default: ''
    },
    min: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: ''
    },
    counter: {
      type: [Boolean, Number, String],
      default: false
    },
    value: {
      type: String
    },
    prependCb: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      menu2: false,
      time: this._value
    }
  },

  computed: {
    errorMessages() {
      return this.vErrors.collect(this.name)
    },
    errorClass() {
      return this.form.errors.has(this.name) && 'input-group--error error--text'
    },
    _value: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('update:value', value.trim())
        this.$emit('input', value.trim())
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/TimePicker.vue